import { useSelector } from 'react-redux';
import useCurrent from './useCurrent';
import { useEffect } from 'react';
import i18next from 'i18next';

const useInvoice = () => {
    const {currentLangId,currentCompany} = useCurrent();
    const settings = useSelector(state => state.settings)
    const SETTING_INVOICE = settings?.invoiceSettings;
    const SETTING_QUOTE = settings?.quoteSettings;

    const initalProductItem = Array.from(Array(parseInt( SETTING_INVOICE?.INV_ITEMS_ROW_NUMBER) || 10),(e,index)=>{
        return {
            index:index,
            productId:'', 
            productName:'',
            productDesc:'',
            qty:'',
            qtyDays:'',
            price:'',
            priceUnit:'',
            productDiscount:'',
            productNetTotal:'',
            productVat:'',
            productNetTotalWithVat:'',
        }
    });

    const toFloat = (valueString,toFixed=true) => {
        if(!SETTING_INVOICE) return 
        const tryToFloat = parseFloat(valueString)
        if(!isNaN(tryToFloat)){
            if( tryToFloat && toFixed ){
                return  tryToFloat.toFixed(SETTING_INVOICE.INV_TO_FIXED_NUMBER)
            }else if( tryToFloat && !toFixed ){
                return  tryToFloat
            }
        }
        return 0;
    }

    const calcSumPrice = (productList) => {
        const totalAmount = productList.reduce((accumulatar ,obj) => {
            if( obj !== undefined && obj.price !== undefined && obj.price != null && !isNaN(obj?.price) )
                return  ( toFloat(accumulatar,false) + toFloat( obj?.price,false) )
            else
                return toFloat(accumulatar,false)
        
            },0);
        return toFloat(totalAmount,false);
    }

    const calcSumNetTotal = (productList) => {
        if(productList){
        console.log('productList',productList);
        
        const totalAmount = productList.reduce((accumulatar ,obj) => {
            if( obj !== undefined && obj.productNetTotal !== undefined && obj.productNetTotal != null && !isNaN(obj?.productNetTotal) )
                return  ( toFloat(accumulatar,false) + toFloat( obj?.productNetTotal,false) )
            else
                return toFloat(accumulatar,false)
        
            },0);
        return toFloat(totalAmount,false);
        }
    }

    const calcVat = (amountValue) => {
        console.log('SETTING_INVOICE',SETTING_INVOICE);
        if(!SETTING_INVOICE) return 
        let amountWithVat = 0 ;
        amountWithVat = amountValue * (parseFloat(SETTING_INVOICE.INV_VAT_PERCENT)/100)
        return amountWithVat;
    }
    
    useEffect(()=>{
        
    },[])
    
    
    let currency;
    if (currentCompany?.currency) {
      const companyCurrentcy = currentCompany.currency.trim();
      currency = companyCurrentcy === "R" ? "SAR" : companyCurrentcy;
      if (currency.length < 3) {
        currency = SETTING_INVOICE?.INV_CURRENCY || 'SAR';
      }
    } else {
      currency = SETTING_INVOICE?.INV_CURRENCY || 'SAR';
    }
    
    const formatter = new Intl.NumberFormat(`${currentLangId || 'en'}-US`, {
      style: 'currency',
      currency: currency
    });

    const formatAmount = (amount, currencyInfo) => {
    if (currencyInfo) {
      const currencyCode = currencyInfo.currency_code?.trim() || 'SAR';
      const itemFormatter = new Intl.NumberFormat(i18next.language, {
        style: 'currency',
        currency: currencyCode.toUpperCase()
      });
      
      return itemFormatter.format(amount);
    }
    
    return formatter.format(amount);
  };

    return {
        SETTING_INVOICE,
        SETTING_QUOTE,
        initalProductItem,
        calcSumPrice,
        calcSumNetTotal,
        toFloat,
        calcVat,
        formatter,
        formatAmount
    }

}

export default useInvoice
